import { DataSourceForm } from "@/components/data-source/data-source-form";

export function NewDataSourcePage() {
  return <DataSourceForm mode="create" />;
}
